import { render, staticRenderFns } from "./PrintsSettings.vue?vue&type=template&id=468faa44&"
import script from "./PrintsSettings.vue?vue&type=script&lang=js&"
export * from "./PrintsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports